Object.defineProperty(exports,"__esModule",{value:true});exports.isDev=void 0;var isDev=typeof __DEV__!=='undefined'?__DEV__:true;exports.isDev=isDev;
//# sourceMappingURL=is-dev.js.map